module.exports = __webpack_public_path__ + "img/spoken_al_detail_voice.5441861e.svg";